import { DetailsSkeleton } from './details.skeleton';
import { FormSkeleton } from './form.skeleton';
import { GeneralInformationSkeleton } from './general-information.skeleton';

export const CandidateFormSkeleton = () => {
  return (
    <div className="tw-flex tw-flex-col tw-w-full">
      <DetailsSkeleton />
      <GeneralInformationSkeleton />
      <FormSkeleton />
    </div>
  );
};
